export enum ProductInstallStatus {
    INITIALIZING = 'Initializing',
    RESUMING = 'Resuming',
    UPDATING = 'Updating',
    INSTALLING = 'Installing',
    CLOUD_SYNCING = 'CloudSyncing',
    UNINSTALLING = 'Uninstalling',
    BUILD_VERIFICATION = 'Verifying',
    CLEANUP = 'CleanUp',
    PREREQUISITES_INSTALL = 'PrerequisitesInstall',
    COMPLETED = 'Completed',
    PAUSED = 'Paused',
    QUEUED = 'Queued',
    PLEASE_WAIT = 'Please Wait..'
}

export const productInstallStatusMessageCodes = {
    [ProductInstallStatus.INITIALIZING]: 'diesel.common.smart_button.initializing',
    [ProductInstallStatus.RESUMING]: 'diesel.common.smart_button.resuming',
    [ProductInstallStatus.UPDATING]: 'diesel.common.smart_button.updating',
    [ProductInstallStatus.INSTALLING]: 'diesel.common.smart_button.installing',
    [ProductInstallStatus.CLOUD_SYNCING]: 'diesel.common.smart_button.cloud_syncing',
    [ProductInstallStatus.UNINSTALLING]: 'diesel.common.smart_button.uninstalling',
    [ProductInstallStatus.BUILD_VERIFICATION]: 'diesel.common.smart_button.build_verification',
    [ProductInstallStatus.CLEANUP]: 'diesel.common.smart_button.cleanup',
    [ProductInstallStatus.PREREQUISITES_INSTALL]:
        'diesel.common.smart_button.prerequisites_install',
    [ProductInstallStatus.COMPLETED]: 'diesel.common.smart_button.completed',
    [ProductInstallStatus.PAUSED]: 'diesel.common.smart_button.paused',
    [ProductInstallStatus.QUEUED]: 'diesel.common.smart_button.queued',
    [ProductInstallStatus.PLEASE_WAIT]: 'diesel.common.smart_button.please_wait'
};

export default {
    updateStatus: ProductInstallStatus,
    updateStatusMessageCodes: productInstallStatusMessageCodes
};
